import { useEffect, useState } from "react";
import Table from "./Table";
import { getDay, getFormattedDate } from "../utils";

function DownloadTable(props) {
  const [print, setPrint] = useState(false);

  useEffect(() => {
    if (!print) return;
    function openPrint() {
      window.print();
    }
    function handleAfterPrint() {
      window.location.href = `/lessonplans/${props.plan._id}?action=preview`;
    }
    //attach listener
    window.addEventListener("afterprint", handleAfterPrint);

    setTimeout(() => {
      openPrint();
    }, 500);

    //remove listener
    return () => {
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [print]);

  return (
    <div
      className="lp-table lp-table-download"
      style={{ width:"100%" }}
    >
      <h1 style={{ textAlign: "center", margin: "20px 0 0 0" }}>
        {props?.plan?.schoolId?.name || ""}
      </h1>
      <div className="lp-table-info">
        <div>Teacher Name: <u>{props?.plan?.teacherId?.name || ""}</u></div>
        <div>Date: <u>{getFormattedDate(props.plan.startDate,"-","DD-MM-YY")}</u></div>
        <div>Day: <u>{getDay(props.plan.startDate)}</u></div>
      </div>
      <Table
        showAll={true}
        extraValues={{
          Period: "Flexible",
          Grade: `${props.plan?.sectionId?.grade || ""}-${
            props.plan?.sectionId?.section || ""
          }`,
          Subject: props.plan?.subjectId?.name,
          Chapter: props.plan?.chapterId?.name || props.plan?.customChapter,
          Topic: props.plan?.topicId?.name || props.plan?.customTopic,
          "Sub Topic": props.plan?.moduleId?.name || props.plan?.customModule,
        }}
        plan={props.plan}
        print={print}
        setPrint={setPrint}
        className="download-table"
      />
      <p style={{ fontSize: "0.8rem", textAlign: "center", marginTop: "20px" }}>
        Lesson Plan Powered by <a href="https://2xcell.in">2xcell</a>
      </p>
    </div>
  );
}

export default DownloadTable;
